"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchRoute = undefined;

var _asyncToGenerator2 = require("@babel/runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _regenerator = require("@babel/runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.object.assign.js");

var _vue = require("vue");

var _vue2 = _interopRequireDefault(_vue);

var _index = require("../store/index");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

// import App from './app.mpx?app=true'
_vue2.default.config.devtools = true; // import store from '../store/index'

_vue2.default.config.productionTip = true;
var matchRoute = exports.matchRoute = function matchRoute(routes, path) {
    try {
        console.log('matchRoutes--------', routes, path);
        var route = routes.find(function func_trir_2771da66e7a246700d80cb2b851c79ce(item) {
            try {
                return path === '/' ? item.path === path : item.path.includes(path);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_2771da66e7a246700d80cb2b851c79ce@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
        console.log('matchRoutes', path, route);
        if (route.redirect) {
            route = routes.find(function func_trir_df14af58adf2824efac38aeff9cb3d89(item) {
                try {
                    return item.path === route.redirect;
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_df14af58adf2824efac38aeff9cb3d89@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        }
        return route;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('matchRoute@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};

var getAsyncData = /*#__PURE__*/function func_trir_a963e5a3b8d06d7234d81c525bc38fb0() {
    try {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref) {
            try {
                var context, fetch, store, router, fetchData;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    try {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                context = _ref.context, fetch = _ref.fetch, store = _ref.store, router = _ref.router;
                                fetchData = {};
                                if (!fetch) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 5;
                                return fetch({
                                    store: store,
                                    router: router
                                }, context);
                            case 5:
                                fetchData = _context.sent;
                            case 6:
                                return _context.abrupt('return', Object.assign({}, fetchData || {}));
                            case 7:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee$@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, _callee);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }));
        return function getAsyncData(_x) {
            try {
                return _ref2.apply(this, arguments);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('getAsyncData@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_a963e5a3b8d06d7234d81c525bc38fb0@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}();

var ClientRender = /*#__PURE__*/function func_trir_5193f7327ccda5dfe1cd2977230bc606() {
    try {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            try {
                var store, App, router, app;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    try {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                            case 0:
                                store = (0, _index.getStore)();
                                if (window.__INITIAL_STATE__) {
                                    store.state = window.__INITIAL_STATE__;
                                }
                                App = require('../views/index/app.mpx?app=true')['default'];
                                router = global.__mpxRouter;
                                console.log('client-router', App, router);
                                app = new _vue2.default({
                                    router: router,
                                    render: function render(h) {
                                        try {
                                            return h(App);
                                        } catch (e)
                                                                                        {
                                                'use strict';
                                                var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                    try {
                                                        JSON.stringify(k);
                                                        return true;
                                                    } catch (e) {
                                                        return false;
                                                    }
                                                });
                                                window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('render@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                                    stack: e.stack,
                                                    arguments: omegaParams
                                                }) : '';
                                                throw e;
                                            }
                                    }
                                });
                                router.beforeResolve(function func_trir_b0c8c677572a295e2a828fde71a4284a() {
                                    try {
                                        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(to, from, next) {
                                            try {
                                                var curRoute, route, fetch, fetchData;
                                                return _regenerator2.default.wrap(function _callee2$(_context2) {
                                                    try {
                                                        while (1) {
                                                            switch (_context2.prev = _context2.next) {
                                                            case 0:
                                                                console.log('before resolve', to, from, router);
                                                                curRoute = router.currentRoute;
                                                                route = matchRoute(router.options.routes, curRoute.path);
                                                                fetch = require('../views/index/fetch')['default'];
                                                                _context2.next = 6;
                                                                return getAsyncData({
                                                                    fetch: fetch,
                                                                    store: store,
                                                                    router: to
                                                                });
                                                            case 6:
                                                                fetchData = _context2.sent;
                                                                console.log('fetchData', route, fetchData);
                                                                next();
                                                            case 9:
                                                            case 'end':
                                                                return _context2.stop();
                                                            }
                                                        }
                                                    } catch (e)
                                                                                                                {
                                                            'use strict';
                                                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                                try {
                                                                    JSON.stringify(k);
                                                                    return true;
                                                                } catch (e) {
                                                                    return false;
                                                                }
                                                            });
                                                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee2$@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                                                stack: e.stack,
                                                                arguments: omegaParams
                                                            }) : '';
                                                            throw e;
                                                        }
                                                }, _callee2);
                                            } catch (e)
                                                                                                {
                                                    'use strict';
                                                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                        try {
                                                            JSON.stringify(k);
                                                            return true;
                                                        } catch (e) {
                                                            return false;
                                                        }
                                                    });
                                                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee2@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                                        stack: e.stack,
                                                        arguments: omegaParams
                                                    }) : '';
                                                    throw e;
                                                }
                                        }));
                                        return function func_trir_1e449e3a139e09c1db1d17aee18f7e86(_x2, _x3, _x4) {
                                            try {
                                                return _ref4.apply(this, arguments);
                                            } catch (e)
                                                                                                {
                                                    'use strict';
                                                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                        try {
                                                            JSON.stringify(k);
                                                            return true;
                                                        } catch (e) {
                                                            return false;
                                                        }
                                                    });
                                                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_1e449e3a139e09c1db1d17aee18f7e86@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                                        stack: e.stack,
                                                        arguments: omegaParams
                                                    }) : '';
                                                    throw e;
                                                }
                                        };
                                    } catch (e)
                                                                                {
                                            'use strict';
                                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                try {
                                                    JSON.stringify(k);
                                                    return true;
                                                } catch (e) {
                                                    return false;
                                                }
                                            });
                                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_b0c8c677572a295e2a828fde71a4284a@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                                stack: e.stack,
                                                arguments: omegaParams
                                            }) : '';
                                            throw e;
                                        }
                                }());
                                router.onReady((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                                    try {
                                        return _regenerator2.default.wrap(function _callee3$(_context3) {
                                            try {
                                                while (1) {
                                                    switch (_context3.prev = _context3.next) {
                                                    case 0:
                                                        console.log('router.onReady');
                                                        app.$mount('.app', true);
                                                    case 2:
                                                    case 'end':
                                                        return _context3.stop();
                                                    }
                                                }
                                            } catch (e)
                                                                                                {
                                                    'use strict';
                                                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                        try {
                                                            JSON.stringify(k);
                                                            return true;
                                                        } catch (e) {
                                                            return false;
                                                        }
                                                    });
                                                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee3$@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                                        stack: e.stack,
                                                        arguments: omegaParams
                                                    }) : '';
                                                    throw e;
                                                }
                                        }, _callee3);
                                    } catch (e)
                                                                                {
                                            'use strict';
                                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                try {
                                                    JSON.stringify(k);
                                                    return true;
                                                } catch (e) {
                                                    return false;
                                                }
                                            });
                                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee3@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                                stack: e.stack,
                                                arguments: omegaParams
                                            }) : '';
                                            throw e;
                                        }
                                })));
                            case 8:
                            case 'end':
                                return _context4.stop();
                            }
                        }
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee4$@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, _callee4);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee4@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }));
        return function ClientRender() {
            try {
                return _ref3.apply(this, arguments);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('ClientRender@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_5193f7327ccda5dfe1cd2977230bc606@@../../../../src/entry/app-client.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}();

ClientRender();